import { render, staticRenderFns } from "./HostingSiteBuilder.vue?vue&type=template&id=a65e2130&"
import script from "./HostingSiteBuilder.vue?vue&type=script&lang=js&"
export * from "./HostingSiteBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a65e2130')) {
      api.createRecord('a65e2130', component.options)
    } else {
      api.reload('a65e2130', component.options)
    }
    module.hot.accept("./HostingSiteBuilder.vue?vue&type=template&id=a65e2130&", function () {
      api.rerender('a65e2130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/HostingSiteBuilder.vue"
export default component.exports